import React from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setReviewerViewSettings, useReviewersSettings } from 'reducers/reviewCreationSlice';

import { PeerSettings } from 'assets/assetsV1/iconComponents';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';
import { RadioSelect } from 'uiToolkitV1/RadioSelect';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { NominationCountSettings } from './NominationCountSetting';

export const PeerNominationSettings = ({ feedbackFormId }) => {
  const dispatch = useDispatch();
  const { isAutoAcceptPeerNomination, isAutoAcceptDlmNomination, isAllowPeerNominationBySelf, enabledProviderTypes } =
    useReviewersSettings({
      feedbackFormId,
    });

  const onChangeHandler = (newValueBool, propertyName) => {
    dispatch(
      setReviewerViewSettings({
        feedbackFormId,
        settings: { [propertyName]: newValueBool },
      })
    );
  };

  const isPeerReviewEnabled = enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.PEER);
  const isDLMReviewEnabled = enabledProviderTypes.includes(REVIEW_PROVIDER_TYPES.DLM);

  if (!isPeerReviewEnabled && !isDLMReviewEnabled) {
    return null;
  }

  return (
    <ExpandablePaper>
      <ExpandablePaperHeader
        title="Peer/Dotted Line Manager nomination settings"
        leftIconComponent={<PeerSettings boxSize="24px" color="icon.g2" />}
      />
      <ExpandablePaperBody>
        {isPeerReviewEnabled && (
          <Box p="10px 8px">
            <TextBodyMedium mr={2} mb="2px">
              Once nominated, are Peer nominations automatically accepted?
            </TextBodyMedium>

            <RadioSelect
              options={[{ name: 'Yes' }, { name: 'No' }]}
              selectedIndex={isAutoAcceptPeerNomination ? 0 : 1}
              onChange={(index) => onChangeHandler(index === 0, 'isAutoAcceptPeerNomination')}
            />
          </Box>
        )}

        {isDLMReviewEnabled && (
          <Box p="10px 8px">
            <TextBodyMedium mr={2} mb="2px">
              Once nominated, are Dotted Line Manager nominations automatically accepted?
            </TextBodyMedium>

            <RadioSelect
              options={[{ name: 'Yes' }, { name: 'No' }]}
              selectedIndex={isAutoAcceptDlmNomination ? 0 : 1}
              onChange={(index) => onChangeHandler(index === 0, 'isAutoAcceptDlmNomination')}
            />
          </Box>
        )}

        <Box p="10px 8px" mt={3}>
          <TextBodyMedium mr={2} mb="2px">
            Who can nominate?
          </TextBodyMedium>
          <TextLabel color="text.g2">Note: Admin can nominate in any situation</TextLabel>

          <RadioSelect
            options={[{ name: 'Self and Manager' }, { name: 'Manager Only' }]}
            selectedIndex={isAllowPeerNominationBySelf ? 0 : 1}
            onChange={(index) => onChangeHandler(index === 0, 'isAllowPeerNominationBySelf')}
          />
        </Box>
        {isPeerReviewEnabled && <NominationCountSettings feedbackFormId={feedbackFormId} />}
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
